import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class RatingQueryService {
    public GET_CURRENT_ORDER_RATING_DATA: any;

    constructor(public apollo: Apollo) {
        this.GET_CURRENT_ORDER_RATING_DATA =
            gql`
      query GET_CURRENT_ORDER_RATING_DATA($orderId:Int){
        allRatings(condition:{orderId:$orderId}) {
        edges {
          node {
            icId
            rating
            orderId
            insReportId
            createdAt           
          }
        }
      }
      }
        `
    }
    //Get rating of this order
    GET_CURRENT_ORDER_RATING(orderId) {
        return this.apollo.watchQuery({
            query: this.GET_CURRENT_ORDER_RATING_DATA,
            variables: {
                "orderId": Number.parseInt(orderId),
            },
            fetchPolicy: 'network-only'
        })
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/ratings.ts